import { useTranslation } from "react-i18next";
import { FormDatePicker } from "@/shared/Components";
import { getCurrentDate } from "@/shared/utils";
import type { AppDatePickerProps } from "@/shared/Components/AppDatePicker";
import styles from "./styles.module.scss";

const disabledDate: AppDatePickerProps["disabledDate"] = (current) => {
  return current && current > getCurrentDate(true).endOf("day");
};

export const DateSelect = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <p className={styles.label}>{t("common.date")}</p>
      <FormDatePicker
        format={{
          format: "DD-MM-YYYY",
          type: "mask",
        }}
        disabledDate={disabledDate}
        name={"currentNote.noteDate"}
      />
    </div>
  );
};
